import React from 'react'
import { Button, Popup } from 'semantic-ui-react'
import { css } from 'emotion'
import SearchForm from './SearchForm'
import { Redirect } from 'react-router-dom'

export default class Header extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      searchText: this.props.worksheetSearchText || '',
      redirectToSearch: false
    }
  }

  componentDidUpdate() {
    this.state.redirectToSearch = false
  }

  handleSearchFormChange = (e) => {
    this.setState({
      searchText: e.target.value
    })
  }

  handleSearchFormClear = (e) => {
    this.setState({
      searchText: '',
      redirectToSearch: true
    })
  }

  handleSearch = () => {
    this.setState({
      redirectToSearch: true
    })
  }

  render() {
    if (this.state.redirectToSearch) {
      const searchText = encodeURIComponent(this.state.searchText)
      const query = '?search='
      const params = new URLSearchParams(location.search)

      if (params.get('search') !== searchText) {
        const search = searchText !== void 0 && searchText !== '' ? query + searchText : ''
        return <Redirect to={{pathname: '/home', search: search }}></Redirect>
      }
    }

    return (
      <div className={style}>
        <div className='title'>Off Price Workspace</div>
        <div className='collapse-menu-button'>
          <Button icon='bars' circular basic inverted onClick={this.props.onToggleSidepanel} />
        </div>
        
        <div className='toolbar'>
          <Popup
            inverted position='bottom center'
            trigger={
              <Button
                icon='cog'
                href='http://mymacys.net/applications/preferences/pages/kstpreferences.aspx'
                target='_blank'
                circular
                basic
                inverted
              />
            }
            content='User Preferences'
          />
          <Popup
            inverted position='bottom center'
            trigger={<Button icon='log out' href='/logout' circular basic inverted />}
            content='Log out'
          />
        </div>
      </div>
    )
  }

}


const style = css`
  & {
    display: flex;
    align-items: center;
    position: relative;
    -ms-flex-direction: row;
    flex-direction: row;
    height: 50px;
    padding: 0;
    margin: 0;
    background-color: #34383c;
    border-bottom: 1px solid #34383c;

    .title {
      display: -ms-inline-flexbox;
      display: inline-flex;
      -ms-flex-align: center;
      align-items: center;
      -ms-flex-pack: center;
      justify-content: center;
      width: 240px;
      height: 50px;
      padding: 0;
      margin-right: 0;
      background-color: #1c1f21;
      border-bottom: 1px solid #1c1f21;
      color: #FFFFFF;
    }

    .collapse-menu-button {
      display: -ms-inline-flexbox;
      display: inline-flex;
      margin-left: 15px;
    }

    .search-form {
      display: -ms-inline-flexbox;
      display: inline-flex;
      margin-left: 15px;
    }

    .toolbar {
      display: -ms-inline-flexbox;
      display: inline-flex;
      justify-content: flex-end;
      -ms-flex-direction: row;
      flex-direction: row;
      -ms-flex-align: center;
      align-items: center;
      margin-left: 150px;
      margin-right: 18px;
      width: auto;
      flex: 2;

      & > * {
        text-align: center;
      }
    }
  }
`


// WEBPACK FOOTER //
// ./components/header/Header.js